module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/knee-75df0fb458415cdbf7ba31bfe017522c.png";